import React, { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import useStore from "../../store/useStore";
import Header from "./Header";
import Sidebar from "./Sidebar";
import GuideTour from "./GuideTour";
import { getMenuItems, guideStorageKey } from "./appMenu";

const Layout = ({ children }) => {
  const { pathname } = useLocation();
  const { user, authRole } = useStore();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [guideOpen, setGuideOpen] = useState(() => {
    const key = guideStorageKey(user);
    if (!key || !getMenuItems(authRole || user?.role).length) return false;
    return localStorage.getItem(key) !== "1";
  });
  const role = authRole || user?.role;
  const guideSteps = getMenuItems(role);
  const seenKey = guideStorageKey(user);

  const toggleSidebar = useCallback(() => setSidebarOpen((open) => !open), []);
  const closeSidebar = useCallback(() => setSidebarOpen(false), []);
  const closeGuide = useCallback(() => {
    if (seenKey) localStorage.setItem(seenKey, "1");
    setGuideOpen(false);
    setSidebarOpen(false);
  }, [seenKey]);
  const showGuide = useCallback(() => setGuideOpen(true), []);

  useEffect(() => {
    setSidebarOpen(false);
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    if (!seenKey || !guideSteps.length) return undefined;
    if (localStorage.getItem(seenKey) === "1") return undefined;
    setGuideOpen(true);
  }, [seenKey, guideSteps.length]);

  return (
    <div className="system-shell flex min-h-dvh w-full max-w-[100vw] overflow-x-clip bg-gradient-to-br from-teal-50 via-white to-teal-100">
      <Sidebar isOpen={sidebarOpen || guideOpen} immediate={guideOpen} closeSidebar={closeSidebar} />

      <div className="flex min-w-0 flex-1 flex-col lg:ml-64">
        <Header toggleSidebar={toggleSidebar} onShowGuide={showGuide} />

        <main className="flex-1 min-w-0 bg-gradient-to-br from-white via-teal-50/40 to-teal-50">
          <div className="mx-auto w-full max-w-screen-2xl px-4 py-4 sm:px-6 sm:py-6 lg:px-8 pb-[max(1.5rem,env(safe-area-inset-bottom))]">
            {children}
          </div>
        </main>
      </div>
      <GuideTour open={guideOpen} steps={guideSteps} onClose={closeGuide} />
    </div>
  );
};

export default Layout;
